import { useTheme } from "design-system/themeContext";

export const Logo = ({ className = "", height, onClick, style = {}, variant = "main", width }) => {
  const theme = useTheme();
  const src = variant === "sidebar" ? theme.logo.sidebarSrc : theme.logo.mainSrc;

  return (
    <img
      alt={theme.logo.alt}
      className={className}
      height={height}
      onClick={onClick}
      src={src}
      style={style}
      width={width}
    />
  );
};

export default Logo;
